import React from "react";
import { useTranslation } from "react-i18next";
import useReveal from "./useReveal";

// One academic year on the road map. Figures are printed only when the poster
// provides them; a year without figures (remote learning during Covid) shows
// its description instead.
const JourneyMilestone = ({ milestone }) => {
  const { t } = useTranslation("roadmap");
  const [ref, revealed] = useReveal();

  const {
    id,
    yearHijri,
    yearGregorian,
    students,
    teachers,
    remote,
    current,
  } = milestone;

  const description = t(`milestones.${id}.description`, { defaultValue: "" });

  return (
    <article
      ref={ref}
      id={`year-${id}`}
      className={[
        "rm-milestone",
        current ? "rm-milestone--current" : "",
        revealed ? "is-revealed" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span className="rm-milestone__dot" aria-hidden="true" />

      <div className="rm-milestone__card">
        <div className="rm-milestone__year">
          <span className="rm-milestone__year-hijri" dir="ltr">
            {yearHijri}
          </span>
          <span className="rm-milestone__year-gregorian" dir="ltr">
            {yearGregorian}
          </span>
        </div>

        <div className="rm-milestone__body">
          <div className="rm-milestone__stats">
            {typeof students === "number" && (
              <div className="rm-milestone__stat rm-milestone__stat--students">
                <i className="fi flaticon-user" aria-hidden="true" />
                <div>
                  <span className="rm-milestone__stat-label">
                    {t("timeline.students")}
                  </span>
                  <span className="rm-milestone__stat-value" dir="ltr">
                    {students}
                  </span>
                </div>
              </div>
            )}

            {typeof teachers === "number" && (
              <div className="rm-milestone__stat rm-milestone__stat--teachers">
                <i className="fi flaticon-graduation-cap" aria-hidden="true" />
                <div>
                  <span className="rm-milestone__stat-label">
                    {t("timeline.teachers")}
                  </span>
                  <span className="rm-milestone__stat-value" dir="ltr">
                    {teachers}
                  </span>
                </div>
              </div>
            )}

            {remote && (
              <div className="rm-milestone__stat rm-milestone__stat--remote">
                <i className="ti-desktop" aria-hidden="true" />
                <span className="rm-milestone__stat-label">
                  {t("timeline.remote")}
                </span>
              </div>
            )}
          </div>

          {description && (
            <p className="rm-milestone__description">{description}</p>
          )}
        </div>

        {current && (
          <span className="rm-milestone__badge">{t("timeline.current")}</span>
        )}
      </div>
    </article>
  );
};

export default JourneyMilestone;
